import {ChildEntity} from "typeorm";
import {StaffMember} from "@/modules/staff/entity";

@ChildEntity('scout')
export class Scout extends StaffMember {
}
